import React from "react";
import { View } from "native-base";
import { Pagination } from "react-native-reanimated-carousel";

type ExpandedImagePaginationProps = {
  visible: boolean;
  progress: any;
  data: any[];
  onPressDot: (index: number) => void;
  wrapperStyle: any;
  containerStyle: any;
  dotStyle: any;
  activeDotStyle: any;
};

const ExpandedImagePagination: React.FC<ExpandedImagePaginationProps> = ({
  visible,
  progress,
  data,
  onPressDot,
  wrapperStyle,
  containerStyle,
  dotStyle,
  activeDotStyle,
}) => {
  if (!visible) return null;

  return (
    <View style={wrapperStyle}>
      <Pagination.Custom
        progress={progress}
        data={data}
        onPress={onPressDot}
        dotStyle={dotStyle}
        activeDotStyle={activeDotStyle}
        containerStyle={containerStyle}
      />
    </View>
  );
};

export default React.memo(ExpandedImagePagination);
